import { OBJECT_TYPE_GENERAL_ADMISSION } from '%paysera_seat_selection/js/seatSelection/config/constants';

const groupUsedSeatsByGeneralAdmission = seatings => seatings.reduce(
    (accumulator, currentValue) => {
        const { type, hash } = currentValue;
        if (type !== OBJECT_TYPE_GENERAL_ADMISSION) {
            return accumulator;
        }

        return {
            ...accumulator,
            [hash]: accumulator[hash] ? accumulator[hash] + 1 : 1,
        };
    },
    {},
);

export default groupUsedSeatsByGeneralAdmission;
